import { __exportAll } from "../../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../../validators/parse.js";
import { z } from "zod";
//#region src/cues/v1/media/cues/get/list.ts
var list_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var CueSchema = z.object({
	name: z.string(),
	position: z.string(),
	userId: z.string(),
	uuid: z.string(),
	visibility: z.enum([
		"private",
		"org",
		"public"
	])
});
var ResponseSchema = z.array(CueSchema);
var parse = parseFactory(ResponseSchema);
//#endregion
export { list_exports };

//# sourceMappingURL=list.js.map